const statuses = {
  SUCCESS: 'success',
  ERROR: 'error',
  INTEGRATING: 'integrating',
  NOT_STARTED: 'not_started',
};

const texts = {
  [statuses.SUCCESS]: 'Sucesso',
  [statuses.ERROR]: 'Erro',
  [statuses.INTEGRATING]: 'Integrando',
  [statuses.NOT_STARTED]: 'Não iniciado',
};

export default statuses;

export const getText = (status) => texts[status];
